import {useQuery} from '@tanstack/react-query'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    getLastRecords,
    getLatestRecord,
    getPageActivities,
    getPageHealthRecords,
    getRecordsInDay,
} from '../ObservationEndPoint'

/* Health Records */
export const usePageHealthRecords = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {healthRecordKeys} = QueryKeyManager(
        QueryKeyTypes.healthRecord,
        requestorId,
    )

    return useQuery({
        queryKey: healthRecordKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageHealthRecords(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useNewestHealthRecords = (requestorId, userId, enabled = true) => {
    const {healthActivitiesKeys} = QueryKeyManager(
        QueryKeyTypes.healthActivities,
        requestorId,
    )
    return useQuery({
        queryKey: healthActivitiesKeys.newest({userId}),
        queryFn: () => getLatestRecord(requestorId, userId),
        enabled: !!requestorId && !!userId && !!enabled,
    })
}

export const useListNewestHealthRecords = (
    requestorId,
    userId,
    typeCategory = 'steps',
    enabled = true,
) => {
    const {healthActivitiesKeys} = QueryKeyManager(
        QueryKeyTypes.healthActivities,
        requestorId,
    )
    return useQuery({
        queryKey: healthActivitiesKeys.listNewest({userId, typeCategory}),
        queryFn: () => getLastRecords(requestorId, userId, typeCategory),
        enabled: !!requestorId && !!userId && !!typeCategory && !!enabled,
    })
}

export const useListHealthRecordsInDate = (
    requestorId,
    userId,
    date,
    type,
    enabled = true,
) => {
    const {healthActivitiesKeys} = QueryKeyManager(
        QueryKeyTypes.healthActivities,
        requestorId,
    )
    return useQuery({
        queryKey: healthActivitiesKeys.listInDate({userId, date, type}),
        queryFn: () => getRecordsInDay(requestorId, userId, date, type),
        enabled: !!requestorId && !!userId && !!type && !!enabled,
    })
}

/* Activities */
export const usePageActivities = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {healthActivitiesKeys} = QueryKeyManager(
        QueryKeyTypes.healthActivities,
        requestorId,
    )

    return useQuery({
        queryKey: healthActivitiesKeys.pageActivities({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageActivities(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}
